module.exports = __webpack_public_path__ + "static/stateseal-c3888d4e22709b17fb2981cb3f75c793.png";